// Build-time switch for the personal offline desktop build (Electron shell in
// desktop-spike/windows, see docs/desktop/WINDOWS_LOCAL_PROFILE_OFFLINE_SESSION.md).
//
// This MUST stay a compile-time literal. The website build never sets
// REACT_APP_DESKTOP_LOCAL_PROFILE, so Create React App folds it to `false` and the
// code guarded by it is dead-code-eliminated from the public bundle. Never replace it
// with a runtime check (window global, localStorage, a preload-injected flag): any
// visitor could then switch the local profile on from the DevTools console.
export const isDesktopLocalProfile = process.env.REACT_APP_DESKTOP_LOCAL_PROFILE === "true";

// The local profile owns the device store's existing "guest" workspace. That
// workspace is stored in IndexedDB like any account's, but it never queues or
// uploads anything to the cloud (see deviceProgress.ts and progressSync.ts), so
// the local profile cannot add a write path to any AWS resource.
export const LOCAL_PROFILE_ID = "guest";
